import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { map, Observable } from 'rxjs'

import {
  IResponseListApiDto,
  ISettingsAiCreateDto,
  ISettingsAiDto,
  ISettingsAiMessageCreateDto,
  ISettingsAiMessageDto,
  ISettingsAiTmpDto,
} from '~/core/models'

const SETTINGS_PREFIX = 'settings'
const MESSAGE_PREFIX = 'message'
const AI_PREFIX = 'ai'

@Injectable({
  providedIn: 'any',
})
export class SettingsAiApiService {
  constructor(private http: HttpClient) {}

  getProximilarAiSettingsList(): Observable<ISettingsAiDto[]> {
    return this.http
      .get<IResponseListApiDto<ISettingsAiTmpDto>>(`${SETTINGS_PREFIX}/${AI_PREFIX}/list`)
      .pipe(map(res => res.data.map(res => ({ ...res, settingsMessages: res.settingsMessages.data }))))
  }

  createProximilarAiSettings(settings: ISettingsAiCreateDto): Observable<ISettingsAiDto> {
    return this.http
      .post<ISettingsAiTmpDto>(`${SETTINGS_PREFIX}/${AI_PREFIX}`, settings)
      .pipe(map(res => ({ ...res, settingsMessages: res.settingsMessages.data })))
  }

  updateProximilarAiSettings(settings: ISettingsAiCreateDto): Observable<ISettingsAiDto> {
    return this.http
      .put<ISettingsAiTmpDto>(`${SETTINGS_PREFIX}/${AI_PREFIX}`, settings)
      .pipe(map(res => ({ ...res, settingsMessages: res.settingsMessages.data })))
  }

  deleteProximilarAiSettings(settingsId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${SETTINGS_PREFIX}/${AI_PREFIX}/${settingsId}`)
  }

  getProximilarAiSettingsMessageList(): Observable<ISettingsAiMessageDto[]> {
    return this.http
      .get<IResponseListApiDto<ISettingsAiMessageDto>>(`${SETTINGS_PREFIX}/${AI_PREFIX}/${MESSAGE_PREFIX}/list`)
      .pipe(map(res => res.data))
  }

  createProximilarAiMessageSettings(settings: ISettingsAiMessageCreateDto): Observable<ISettingsAiMessageDto> {
    return this.http.post<ISettingsAiMessageDto>(`${SETTINGS_PREFIX}/${AI_PREFIX}/${MESSAGE_PREFIX}`, settings)
  }

  updateProximilarAiMessageSettings(settings: ISettingsAiMessageCreateDto): Observable<ISettingsAiMessageDto> {
    return this.http.put<ISettingsAiMessageDto>(`${SETTINGS_PREFIX}/${AI_PREFIX}/${MESSAGE_PREFIX}`, settings)
  }

  deleteProximilarAiMessageSettings(settingsId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${SETTINGS_PREFIX}/${AI_PREFIX}/${MESSAGE_PREFIX}/${settingsId}`)
  }
}
